// IMPORTS:

// STYLES
import 'bootstrap/scss/bootstrap.scss'
import 'choices.js/public/assets/styles/choices.min.css'

// Main.scss should always be last, otherwise your styles can be overwrite by styles from libraries
import '../scss/main.scss'
import 'plyr/dist/plyr.css';
import Plyr from 'plyr';

// Popper - neccessary for bootstrap
import '@popperjs/core'

// Bootstrap
import 'bootstrap'

import autosize from 'autosize/dist/autosize.js'

// PLUGINS
import './plugins/PluginLoadDependecies.ts'
import './plugins/PluginOutline.ts'
import './plugins/PluginDeviceType.ts'
import './plugins/PluginRecaptcha.ts'
import './plugins/PluginSVGConverter.ts'
import './plugins/PluginBwMenu.ts'
import './plugins/PluginForm.ts'
import LazyLoad, { LazyMode } from './plugins/PluginLazyLoad.ts'
import LASingleLettersBreaker from './plugins/PluginSingleLetters.ts'
import './plugins/PluginAnalytics.ts'
import './plugins/PluginBlockEmbed.ts'
import { CookiesController } from './plugins/PluginCookies.ts'

import './components/ComponentSmoothScroll.ts'
import './components/ComponentAos.ts'
import './components/ComponentPicker.ts'
import './components/ComponentSelect.ts'

// Create CookiesController instance
window.CookiesController = new CookiesController()

new LASingleLettersBreaker({ autoInit: true })

window.addEventListener('load', () => {
  new LazyLoad({
    rootMargin: '200px',
    root: null,
    threshold: 0,
    imageOptions: {
      classDefault: 'lazy-image',
      classOnLoad: 'lazy-image--active',
    },
    mode: LazyMode.EXCLUDE,
    url: '/api/image/',
    selectors: ['[data-item="svg"]', '[data-nolazy="true"]'],
  })
})

// Reinit lazy load on custom event

window.addEventListener('bw-lazy-reload', () => {
  new LazyLoad({
    rootMargin: '200px',
    root: null,
    threshold: 0,
    imageOptions: {
      classDefault: 'lazy-image',
      classOnLoad: 'lazy-image--active',
    },
    mode: LazyMode.EXCLUDE,
    url: '/api/image/',
    selectors: ['[data-item="svg"]', '[data-nolazy="true"]'],
  })
})

// COMPONENTS

import SimpleBar from 'simplebar'
import 'simplebar/dist/simplebar.min.css'
import { LOAD_TIME } from './libs/Constants.ts'

// Init custom scrollbar
window.addEventListener('load', () => {
  initCustomScroll()
})

// Handle reinit on custom event
document.body.addEventListener('bw-custom-scroll-reload', () => {
  initCustomScroll()
})

function initCustomScroll() {
  // Find all elements where custom scroll should be initialized
  const scrollsContainers = document.querySelectorAll(
    `[data-custom-scroll='init']`,
  )
  if (scrollsContainers.length > 0) {
    scrollsContainers.forEach((container) => {
      // Check if custom srcoll has ben alread init on this container
      if (container.getAttribute('data-custom-scroll-active') != 'true') {
        container.setAttribute('data-custom-scroll-active', 'true')

        new SimpleBar(container, { autoHide: false })
      }
    })
  }
}

// Remove preload class on load
window.addEventListener('load', () => {
  autosize(document.querySelectorAll('[textarea-autosize]'))

  const playerWrapper = document.querySelectorAll(
    `[data-player]`,
  )

  if (playerWrapper.length > 0) {

    const player = new Plyr('[data-player]', {
      controls: [
        'play-large',
        'play',
        'progress',
        'current-time',
        'mute',
        'fullscreen',
      ],
    });

    function fixOverlaidLabel() {
      const overlaidButton = player.elements.container.querySelector('.plyr__control--overlaid');

      if (overlaidButton && overlaidButtonText) {
        overlaidButton.setAttribute('aria-label', overlaidButtonText);
      }
    }
    fixOverlaidLabel();

    let hasPlayedOnce = false;

    player.on('play', () => {
      if (hasPlayedOnce) return;

      hasPlayedOnce = true;

      player.elements.container.classList.add('has-played-once');

      fixOverlaidLabel();
    });

    player.on('pause', () => {
      fixOverlaidLabel();
    });
  }

  // hide loader
  window.setTimeout(() => {
    const loader = document.querySelector("[data-item='loader']")
    const loaderStyle = document.querySelector("[data-item='loader-styles']")

    if (loader && loader.parentNode) {
      loader.parentNode.removeChild(loader)
    }
    if (loaderStyle && loaderStyle.parentNode) {
      loaderStyle.parentNode.removeChild(loaderStyle)
    }
  }, LOAD_TIME)

  // Remove class that prevent transition
  const preload = document.querySelector('body')
  if (preload) {
    preload.classList.remove('preload')
  }

  // File inputs
  const fileUploads = document.querySelectorAll(`[data-item="fileUpload"]`)

  if (fileUploads.length > 0) {
    fileUploads.forEach((fileUpload) => {

      const fileInput = fileUpload.querySelector(`[data-item="fileInput"]`)
      const clearBtn = fileUpload.querySelector(`[data-item="fileClear"]`)

      if (fileInput) {
        const label = fileUpload.querySelector(`[data-item="file-label"]`)
        const fileText = fileUpload.querySelector(`[data-item="fileText"]`)

        fileInput.addEventListener('change', function () {
          if (this.files.length > 0) {
            if (label) label.classList.add('has-file')

            if (fileText) fileText.innerHTML = this.files[0].name // Wyświetla nazwę pliku
          } else {
            if (label) label.classList.remove('has-file')

            if (fileText)
              fileText.innerHTML =
                'Załącz CV <span>(max 5 mb | .jpg | .doc | .pdf)</span>'
          }
        })

        if (clearBtn) {
          clearBtn.addEventListener('click', function () {
            fileInput.value = '' // Czyści input
            label?.classList.remove('has-file')
            fileText.innerHTML =
              'Załącz CV <span>(max 5 mb | .jpg | .doc | .pdf)</span>'
          })
        }
      }
    })
  }
})
document.addEventListener('DOMContentLoaded', function () {
  console.log(
    window.CookiesController.isCookieAccepted('bw-cookie-google-analytics'),
  )
  if (
    window.CookiesController &&
    window.CookiesController.isCookieAccepted('bw-cookie-google-analytics')
  ) {
    document
      .querySelectorAll('script[data-cookie-google-analytics]')
      .forEach(function (el) {
        var script = document.createElement('script')

        if (el.getAttribute('src')) {
          script.src = el.getAttribute('src')
        }

        if (el.innerHTML != '') {
          script.innerHTML = el.innerHTML || ''
        }

        // Copy any other needed attributes from the original script
        if (el.getAttribute('async') !== null) script.async = true
        if (el.getAttribute('defer') !== null) script.defer = true
        document.body.appendChild(script)
      })
  }
})